import { usePlan } from "../_providers/PlanProvider";
import Widget from "../_components/Widget";
import "../_components/Transaction.css"
import { useAuth } from "../_providers/AuthProvider";
import PlanController from "../controllers/PlanController";
import { useEffect, useState } from "react";
import User from "../models/User";

const ProjectMembersWidget = () => {
    const { selectedPlan, reloadPlans, addPlanListener } = usePlan();
    const { user } = useAuth();

    const [planUsers, setPlanUsers] = useState<User[]>([]);

    const deleteMember = (uid: string) => {
        if (!selectedPlan) {
            console.error("No plan selected");
            return;
        }
        PlanController.removeMember(selectedPlan.uid, uid).then(() => {
            reloadPlans();
        }
        ).catch((error) => {
            console.error("Error removing member: " + error.message);
        });
    }


    useEffect(() => {
        if(!selectedPlan) {
            console.error("No plan selected");
            return;
        } else {
            console.log(selectedPlan);
        }
        console.log("useEffect:", selectedPlan.users, [...selectedPlan.users]);

        setPlanUsers(selectedPlan.users);
        addPlanListener("ProjectMembersWidget", (plan) => {
            setPlanUsers(plan.users);
        });
    }, []);

    return (
        <Widget title="Project Members" flex={1} minWidth="300px">
                {!selectedPlan || planUsers.length === 0 ? (
                    <p>No members</p>
                ) : (
                    <div>
                        {planUsers.map((u, index) => (
                            <div key={index} className="transaction dark">
                                <p>{u.displayName}</p>
                                {selectedPlan.owner != user?.uid || u.uid == user?.uid ? null : <p className="delete" onClick={() => deleteMember(u.uid)}><i className="fa-solid fa-trash"></i></p>}
                            </div>
                        ))}
                    </div>
                )}
        </Widget>
    );
};

export default ProjectMembersWidget;
